import {
  GET_CANCEL_SERVICE_SERVLET_FULFILLED,
  GET_CANCEL_SERVICE_SERVLET_PENDING,
  GET_CANCEL_SERVICE_SERVLET_FAILED,
} from "constants-lib/actionTypes"

const initialState = {
  servletCancelServiceDetailsSatus: ``,
  servletCancelServiceDetails: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CANCEL_SERVICE_SERVLET_FULFILLED:
      return {
        ...state,
        servletCancelServiceDetails: action.payload,
        servletCancelServiceDetailsSatus: `fulfilled`,
      }

    case GET_CANCEL_SERVICE_SERVLET_PENDING:
      return {
        ...state,
        servletCancelServiceDetails: initialState.servletCancelServiceDetails,
        servletCancelServiceDetailsSatus: `pending`,
      }

    case GET_CANCEL_SERVICE_SERVLET_FAILED:
      return {
        ...state,
        servletCancelServiceDetailsSatus: `failed`,
      }
    default:
      return state
  }
}
